import { render, staticRenderFns } from "./LabelSelector.vue?vue&type=template&id=e74f408e"
import script from "./LabelSelector.vue?vue&type=script&lang=js"
export * from "./LabelSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports